
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'
import CompanyAutocomplete from '@/components/Autocomplete/company.vue'

const AdminIndex = Vue.extend({
    mixins: [AppMixin],
    components: { ToolbarComponent, CompanyAutocomplete },
    data() {
        return {
            authorized: false,
            loaded: true,
            adminCompany: null as null | Record<string, any>,
            searchTerm: '',
        }
    },
    computed: {
        companyAdmins: {
            get: function () {
                return this.$store.getters.companyAdmins
            },
            set: function (companyAdmins: Array<any>) {
                this.$store.commit('companyAdmins', companyAdmins)
            },
        },

        adminCompanies() {
            return this.$store.getters.adminCompanies
        },

        route() {
            return this.$route.name
        },
    },

    methods: {
        changeCompany(event) {
            this.adminCompany = event
        },
    },
    watch: {
        route: {
            immediate: true,
            handler() {
                this.searchTerm = ''
            },
        },
        companyAdmins: {
            immediate: true,
            deep: true,
            handler() {
                this.authorized = this.isSuperuser
                    ? true
                    : this.companyAdmins.length > 0
                    ? true
                    : false
                if (this.companyAdmins.length > 0 && !this.adminCompany) {
                    this.adminCompany = this.adminCompanies[0]
                }
            },
        },
    },
})

export default AdminIndex
